import {
    Typography, Box,
    Divider, Chip
} from '@mui/material';
import React from "react";
import {
    ReferenceInput,
    FormTab,
    useResourceContext,
    TextField
} from "react-admin";
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";
import {
    AutocompleteInput,
    DateTimeInput,
    NumberInput,
    TextInput,

} from '../../../lib/wrappers/Inputs';
var titleStyle = { color: "#AE223F" }
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}
export const CourseEIAInputTab = (source) => {
    const resource = useResourceContext();
    return <FormTab label="EIA" {...source}>
        <Box flex={4} sx={{ paddingBottom: '20px' }}>
            <Typography variant="h6" style={titleStyle}>
                Course | <small><TextField source="id" label={false} /></small> | <small><TextField source="courseCode" label={false} /></small>
            </Typography>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="General" /></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <TextInput source="courseEIA.policy" label="Policy" fullWidth />
                <TextInput source="courseEIA.practice" label="Practice" fullWidth />
                <TextInput source="courseEIA.project" label="Project" fullWidth />
            </Box>
            <Box flex={1} ml="0.5em">
                <TextInput source="courseEIA.procedure" label="Procedure" fullWidth />
                <TextInput source="courseEIA.function" label="Function" fullWidth />
                <TextInput source="courseEIA.decision" label="Decision" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <TextInput source="courseEIA.whoPolicyPracticeProjectProcedureFunctionDecision" fullWidth label="Who is responsable" />
            </Box>
            <Box flex={1} ml="0.5em">
                <TextInput source="courseEIA.detailsPolicyPracticeProjectProcedureFunctionDecision" fullWidth label="Details of responsibility" />
            </Box>
            <Box flex={1} ml="0.5em">
                <TextInput source="courseEIA.whoAffected" fullWidth label="Who will be affected" />
            </Box>
            <Box flex={1} ml="0.5em">
                <TextInput source="courseEIA.whoConsulted" fullWidth label="Who has been consulted" />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <ReferenceInput reference="Faculty" source="courseEIA.facultyId" linkType="edit" label='Faculty'>
                    <AutocompleteInput optionText="description" label='Faculty' fullWidth />
                </ReferenceInput>
            </Box>
        </Box>

        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1em' }} label="Outline the actual or potential impact on those with protected characteristics. If the impact is negative, detail what will be done to mitigate this impact." /></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <Typography variant='body1' gutterBottom>
                    Protected Characteristic
                </Typography>
            </Box>
            <Box flex={5} ml="0.5em">
                <Typography variant='body1' gutterBottom>
                    Supporting Evidence
                </Typography>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <TextInput source="courseEIA.protectedCharacteristicAge" label="Age" fullWidth />
            </Box>
            <Box flex={5} ml="0.5em">
                <TextInput source="courseEIA.pcaEvidence" label="Evidence" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <TextInput source="courseEIA.protectedCharacteristicDisability" label="Disability" fullWidth />
            </Box>
            <Box flex={5} ml="0.5em">
                <TextInput source="courseEIA.pcdEvidence" label="Evidence" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <TextInput source="courseEIA.genderIdentity" label="Gender Identity" fullWidth />
            </Box>
            <Box flex={5} ml="0.5em">
                <TextInput source="courseEIA.giEvidence" label="Evidence" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <TextInput source="courseEIA.marriagePartnership" label="Marriage / civil partnership" fullWidth />
            </Box>
            <Box flex={5} ml="0.5em">
                <TextInput source="courseEIA.mpEvidence" label="Evidence" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <TextInput source="courseEIA.pregnancyMaternity" label="Pregnancy / Maternity" fullWidth />
            </Box>
            <Box flex={5} ml="0.5em">
                <TextInput source="courseEIA.pmEvidence" label="Evidence" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <TextInput source="courseEIA.race" label="Race" fullWidth />
            </Box>
            <Box flex={5} ml="0.5em">
                <TextInput source="courseEIA.rEvidence" label="Evidence" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <TextInput source="courseEIA.religion" label="Religion" fullWidth />
            </Box>
            <Box flex={5} ml="0.5em">
                <TextInput source="courseEIA.reEvidence" label="Evidence" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <TextInput source="courseEIA.sex" label="Sex " fullWidth />
            </Box>
            <Box flex={5} ml="0.5em">
                <TextInput source="courseEIA.sEvidence" label="Evidence" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={2}>
                <TextInput source="courseEIA.sexualOrientation" label="Sexual orientation " fullWidth />
            </Box>
            <Box flex={5} ml="0.5em">
                <TextInput source="courseEIA.soEvidence" label="Evidence" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1em' }} label="Is there any evidence to indicate this policy / practice / project / procedure / function / decision will have a positive or negative impact on the use of the Welsh language within the University?" /></b></Divider>
            </Box>
        </Box>

        <Box display="flex" width={1}>
            <Box flex={1}>
                <TextInput source="courseEIA.pnImpact" label="Positive or negative impact" fullWidth />
            </Box>
            <Box flex={2} ml="0.5em">
                <NumberInput source="courseEIA.iNumberOfWelshSpeakingStaff" label="Impact on the number of Welsh-speaking staff?" fullWidth />
            </Box>
            <Box flex={2} ml="0.5em">
                <NumberInput source="courseEIA.iNumberOfWelshSpeakingStudent" label="Impact on the number of Welsh-speaking students?" fullWidth />
            </Box>
            <Box flex={3} ml="0.5em">
                <TextInput source="courseEIA.bawImpact" label="Impact on the bilingual academic provision or Welsh language services?" fullWidth />
            </Box>
        </Box>

        <Box display="flex" width={1}>
            <Box flex={5}>
                <TextInput source="courseEIA.bawEvidence" label="Evidence" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>

            <Box flex={5}>
                <TextInput source="courseEIA.policyPracticeProjectProcedureFunctionDecisionEffectWelsh" label="Consider and note how the policy / practice / project / procedure / function / decision could be changed to have a positive effect on opportunities to use the Welsh language." fullWidth />

            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1em' }} label="Will this policy / practice / project / procedure / function / decision assist the institution in its ability to comply with the General Duty of the Equality Act 2010 as set out below?" /></b></Divider>
            </Box>
        </Box>
        <TextInput source="courseEIA.eliminateDhvoHow" label="Eliminate unlawful discrimination, harassment, victimisation and other conduct that is prohibited by the Act. If so, how?" fullWidth />
        <TextInput source="courseEIA.advanceEquialityHow" label="Advance equality of opportunity between persons who share a protected characteristic and those who do not;  If so, how?" fullWidth />
        <TextInput source="courseEIA.fosterRelationsHow" label="Foster good relations between persons who share a protected characteristic and those who do not. If so, how?" fullWidth />
        <TextInput source="courseEIA.briefAssessedDetails" label="Please give brief details of what is to be assessed, including information on whether this is a new, revised or proposed policy / practice / project / procedure / function or decision" fullWidth />
        <TextInput source="courseEIA.impactProtectedCharacteristics" label="Outline the actual or potential impact on those with protected characteristics. If the impact is negative, detail what will be done to mitigate this impact." fullWidth />

        <Box display="flex" width={1}>
            <Box flex={3}>
                <DateTimeInput source="courseEIA.policyPracticeProjectProcedureFunctionDecisionReviewd" label="When will the policy / practice / project / procedure / function / decision be reviewed? " fullWidth />
            </Box>
            <Box flex={5}>

            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1em' }} label="What further actions need to be considered?" /></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <TextInput source="courseEIA.actionsRequired" label="Actions required" fullWidth />
            </Box>
            <Box flex={1} ml="0.5em">
                <TextInput source="courseEIA.staffMemberResponsible" label="Staff member responsible" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <TextInput source="courseEIA.timescale" label="Timescale" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1em' }} label="What is the outcome of this Equality Impact Assessment? " /></b></Divider>
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <TextInput source="courseEIA.outcome1" label="OUTCOME 1 No major change:" fullWidth />
            </Box>
            <Box flex={1} ml="0.5em">
                <TextInput source="courseEIA.outcome2" label="OUTCOME 2 Adjust the proposal:" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <TextInput source="courseEIA.outcome3" label="OUTCOME 3 Continue the proposal:" fullWidth />
            </Box>
            <Box flex={1} ml="0.5em">
                <TextInput source="courseEIA.outcome4" label="OUTCOME 4 Stop and remove the proposal:" fullWidth />
            </Box>
        </Box>
        <Box display="flex" width={1}>
            <Box flex={1}>
                <TextInput source="courseEIA.contact" label="Contact:" fullWidth />
            </Box>
            <Box flex={1} ml="0.5em">
                <DateTimeInput source="courseEIA.contractDate" label="Date" fullWidth />
            </Box>
        </Box>
        <VersioningTypeInput source="versioningType" resource={resource} />
    </FormTab>;
}



